/**
 * 司机管理
 */

export default [
  {
    path: 'order/manage',
    name: '订单管理',
    component: () => import (`@/views/order/index.vue`),
  },
  {
    path: 'order/detail',
    name: '订单详情',
    component: () => import ( `@/views/order/detail`),
  },
  {
    path: 'order/quick-manage',
    name: '订单公海转移',
    component: () => import (`@/views/order/quick-order.vue`),
  },
];

